import { createClient } from '@sanity/client';
import sanityImageUrl from '@sanity/image-url';

import { sanityDataset, sanityProjectId, sanityStage } from './constants';

export const sanityClient = createClient({
  projectId: sanityProjectId,
  dataset: sanityDataset,
  apiVersion: '2025-09-09',
  useCdn: sanityStage === 'prod',
});

export { loyaltyHomepageConfigQuery } from './queries/loyalty-homepage-config';

export const imageUrlBuilder = sanityImageUrl(sanityClient);

export type * from '../sanity.types';
